import React from 'react';
import { ConfigFieldControl, ConfigTextField } from '@sierralabs/core-ui';
import { useConfigComponent } from '../../hooks/component/useConfigComponent';
const SiteConfigLogin = props => {
    var _a, _b, _c, _d;
    const { component, update } = useConfigComponent(props.component);
    return (React.createElement(React.Fragment, null,
        React.createElement(ConfigFieldControl, null,
            React.createElement(ConfigTextField, { fullWidth: true, label: 'Title', value: ((_a = component.props) === null || _a === void 0 ? void 0 : _a.title) || '', onChange: event => {
                    update('props.title', event.target.value);
                } })),
        React.createElement(ConfigFieldControl, null,
            React.createElement(ConfigTextField, { fullWidth: true, label: 'Button Text', value: ((_b = component.props) === null || _b === void 0 ? void 0 : _b.buttonText) || '', onChange: event => {
                    update('props.buttonText', event.target.value);
                } })),
        React.createElement(ConfigFieldControl, null,
            React.createElement(ConfigTextField, { fullWidth: true, label: 'Text Link', value: ((_c = component.props) === null || _c === void 0 ? void 0 : _c.textLink) || '', onChange: event => {
                    update('props.textLink', event.target.value);
                } })),
        component.type === 'site-login' && (React.createElement(ConfigFieldControl, null,
            React.createElement(ConfigTextField, { fullWidth: true, label: 'Redirect Path', value: ((_d = component.props) === null || _d === void 0 ? void 0 : _d.path) || '', onChange: event => {
                    update('props.path', event.target.value);
                } })))));
};
export default SiteConfigLogin;
//# sourceMappingURL=SiteConfigLogin.js.map